var map = {
	"./accessories/earings.png": 1668,
	"./accessories/flower.png": 6695,
	"./accessories/glasses.png": 937,
	"./accessories/headphone.png": 4763,
	"./backgrounds/blue50.png": 3724,
	"./backgrounds/blue60.png": 3595,
	"./backgrounds/blue70.png": 6086,
	"./backgrounds/darkblue30.png": 357,
	"./backgrounds/darkblue50.png": 5680,
	"./backgrounds/darkblue70.png": 9678,
	"./backgrounds/green50.png": 2292,
	"./backgrounds/green60.png": 7531,
	"./backgrounds/green70.png": 7403,
	"./backgrounds/grey40.png": 4163,
	"./backgrounds/grey70.png": 9572,
	"./backgrounds/grey80.png": 6253,
	"./backgrounds/red50.png": 249,
	"./backgrounds/red60.png": 3771,
	"./backgrounds/red70.png": 1804,
	"./backgrounds/yellow50.png": 6981,
	"./backgrounds/yellow60.png": 7745,
	"./backgrounds/yellow70.png": 3379,
	"./ears/default.png": 4437,
	"./ears/tilt-backward.png": 3828,
	"./ears/tilt-forward.png": 1637,
	"./eyes/angry.png": 129,
	"./eyes/default.png": 7402,
	"./eyes/naughty.png": 2382,
	"./eyes/panda.png": 138,
	"./eyes/smart.png": 2330,
	"./eyes/star.png": 1089,
	"./hair/bang.png": 623,
	"./hair/curls.png": 4980,
	"./hair/default.png": 7687,
	"./hair/elegant.png": 4061,
	"./hair/fancy.png": 7902,
	"./hair/quiff.png": 4543,
	"./hair/short.png": 2454,
	"./leg/bubble-tea.png": 6091,
	"./leg/cookie.png": 412,
	"./leg/default.png": 8642,
	"./leg/game-console.png": 7012,
	"./leg/tilt-backward.png": 4918,
	"./leg/tilt-forward.png": 2380,
	"./mouth/astonished.png": 8583,
	"./mouth/default.png": 968,
	"./mouth/eating.png": 7280,
	"./mouth/laugh.png": 8545,
	"./mouth/tongue.png": 2946,
	"./neck/bend-backward.png": 5884,
	"./neck/bend-forward.png": 9518,
	"./neck/default.png": 4385,
	"./neck/thick.png": 4915,
	"./nose/nose.png": 61
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9872;